{
  "contactModal": {
    "delete": {
      "cancel": "Annulla",
      "confirm": "Elimina",
      "error": {
        "contactWithInformationRequests": "contactWithInformationRequests",
        "default": "default",
        "title": "title"
      },
      "message": "Sei sicuro di voler eliminare questo contatto?",
      "success": "success",
      "title": "Elimina contatto"
    }
  },
  "contacts": {
    "buttons": {
      "add": "Aggiungi un contatto"
    },
    "table": {
      "headers": {
        "actions": "Azioni",
        "email": "Email",
        "id": "ID",
        "name": "Nome"
      }
    }
  },
  "onboarding": {
    "actions": {
      "activateAccount": "Attiva account",
      "back": "← Indietro",
      "next": "Avanti"
    },
    "ariaLabel": "Passaggi di onboarding",
    "gate": {
      "retryBanner": {
        "message": "Un errore è accaduto. Per favore, aggiorna e prova di nuovo.",
        "retry": "Prova di nuovo"
      }
    },
    "placeholder": "Contenuto del passaggio in arrivo.",
    "stepIndicator": "Passaggio {{current}} di {{total}}",
    "steps": {
      "my_facilities": {
        "name": "Impianti",
        "subtitle": "Indicaci quali impianti di produzione utilizzi e la loro società madre.",
        "title": "Aggiungi i tuoi impianti di produzione"
      },
      "register_bp": {
        "name": "Partner commerciali",
        "subtitle": "Elenca i contatti chiave delle organizzazioni partner — acquirenti, agenti o subappaltatori da contattare per le richieste di tracciabilità.",
        "title": "Aggiungi i tuoi partner commerciali"
      },
      "review": {
        "name": "Revisione",
        "subtitle": "Verifica che tutto sia corretto prima di attivare il tuo account.",
        "title": "Rivedi i tuoi dati"
      },
      "verify_company": {
        "name": "Verifica azienda",
        "subtitle": "Conferma che abbiamo l'azienda corretta prima di continuare.",
        "title": "Verifica il profilo della tua azienda"
      },
      "welcome": {
        "name": "Benvenuto",
        "subtitle": "",
        "title": "Benvenuto su Trace for Good"
      }
    },
    "verifyCompany": {
      "outcomes": {
        "answer_on_behalf": {
          "description": "For consultants, agents or partners filling in for the company shown above. Next, you'll register your company — responses stay attributed to you as their agent.",
          "label": "This is not my company, but I'm responding on their behalf"
        },
        "claim_company": {
          "description": "Confirm the profile above and continue setup as an employee of this company.",
          "label": "Yes, this is my company — I'd like to validate it"
        },
        "not_related": {
          "description": "Stops this verification. The person who invited you to Trace For Good will be notified so they can rectify the company shown above.",
          "label": "This isn't my company"
        }
      },
      "prompt": "Is this the profile of the company you are working at?",
      "summary": {
        "city": "City",
        "country": "Country",
        "street": "Street"
      }
    },
    "welcome": {
      "checkInfo": "Prima di accedere al tuo account Trace for Good, vorremmo verificare alcune informazioni con te.",
      "intro": "Siamo lieti di darti il benvenuto. Questo portale è stato progettato per facilitare la collaborazione tra partner commerciali di diverse filiere nel contesto della tracciabilità dei prodotti e della conformità.",
      "invitation": "Sei stato invitato sulla piattaforma Trace for Good da <strong>{{invitingCompanyName}}</strong> a partecipare a un processo di tracciabilità dei prodotti. Questo processo potrebbe richiederti di fornire informazioni sulle filiere di approvvigionamento."
    }
  },
  "productionSiteModal": {
    "actions": {
      "addRegistrationId": "Aggiungi ID di registrazione",
      "backToProductionSite": "Torna al modulo del sito",
      "cancel": "Annulla",
      "delete": "Elimina",
      "removeRegistrationId": "Rimuovi ID di registrazione",
      "save": "Salva"
    },
    "createTitle": "Nuovo sito di produzione",
    "delete": {
      "cancel": "Annulla",
      "confirm": "Elimina",
      "message": "Sei sicuro di voler eliminare questo sito di produzione?",
      "title": "Elimina Sito di Produzione"
    },
    "editTitle": "Modifica un sito di produzione",
    "errors": {
      "cityRequired": "La città è obrigatória",
      "coordinatesMaxDecimals": "Latitudine e longitudine possono avere al massimo 6 decimali",
      "countryMustBeValid": "Paese deve essere valido (es. FR, DE)",
      "internalCodeTooLong": "Il codice interno deve essere inferiore a 32 caratteri",
      "nameRequired": "Nome è obrigatório",
      "parentCompanyRequired": "L'azienda madre è obbligatoria",
      "postalCodeTooShort": "Il codice postale deve essere di almeno 3 caratteri",
      "streetRequired": "La via è obrigatória",
      "streetTooShort": "La via deve essere di almeno 3 caratteri"
    },
    "labels": {
      "city": "Città",
      "country": "Paese",
      "internalCode": "Codice interno",
      "latitude": "Latitudine",
      "longitude": "Longitudine",
      "name": "Nome del sito di produzione",
      "parentCompany": "Partner commerciale madre",
      "performedActivities": "Attività svolte",
      "postalCode": "Codice postale",
      "registrationId": "ID di registrazione del sito",
      "street": "Via"
    },
    "parentCompanyChange": {
      "cancel": "Mantieni l'azienda madre attuale",
      "confirm": "Modifica azienda madre",
      "message": "L'azienda madre è l'azienda a cui appartiene questo sito. Modificarla aggiornerà la proprietà di questa struttura e potrebbe influire sul routing della tracciabilità.",
      "title": "Modificare l'azienda madre?"
    },
    "placeholders": {
      "city": "es. Casablanca",
      "country": "Seleziona il paese del sito",
      "internalCode": "es. BD-DAK-001 o riferimento interno",
      "latitude": "Latitudine",
      "longitude": "Longitudine",
      "name": "es. Unità Taglio e Cucito Dhaka A",
      "parentCompany": "ej. Trace for Good",
      "performedActivities": "es. Taglio, cucito, finitura, tintura",
      "postalCode": "Codice postale",
      "registrationId": "es. P.IVA, CIN, GSTIN, USC",
      "street": "Via"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS: 9 cifre.",
      "EORI": "EORI: codice paese + 14 cifre.",
      "GLN": "GLN: 13 cifre.",
      "OTHER": "Altro: max 32 caratteri.",
      "RCS": "RCS: RCS + spazio + nome azienda + spazio + [A,B] + spazio + 9 cifre.",
      "VAT": "VAT: codice paese (es. FR) + 2 cifre + 9 cifre SIREN."
    },
    "registrationIdErrors": {
      "DUNS": "L'ID di registrazione DUNS deve essere un numero di 9 cifre.",
      "EORI": "L'ID di registrazione EORI deve essere nel formato: codice paese (es. FR) + 14 cifre.",
      "GLN": "L'ID di registrazione GLN deve essere un numero di 13 cifre.",
      "OTHER": "L'ID di registrazione altro deve essere inferiore a 32 caratteri.",
      "RCS": "L'ID di registrazione RCS deve essere nel formato: RCS + spazio + nome azienda + spazio + [A,B] + spazio + 9 cifre.",
      "VAT": "L'ID di registrazione VAT deve essere nel formato: codice paese (es. FR) + chiave 2 cifre + numero SIREN 9 cifre."
    },
    "tabs": {
      "generalInfo": "Informazioni generali",
      "location": "Posizione"
    },
    "tooltips": {
      "address": "Il tuo indirizzo di spedizione",
      "city": "Città",
      "country": "Paese del sito di produzione",
      "internalCode": "Codice interno del sito di produzione",
      "latitude": "Latitudine",
      "longitude": "Longitudine",
      "name": "Nome del sito di produzione",
      "parentCompany": "Azienda proprietaria dello stabilimento, selezionata dall'elenco dei partner commerciali registrati.",
      "parentCompanyEdit": "Seleziona l'azienda proprietaria di questo sito.",
      "parentCompanyReadOnly": "Solo l'organizzazione che ha creato o possiede questo stabilimento può modificare l'azienda madre.",
      "performedActivities": "Attività svolte nel sito di produzione",
      "postalCode": "Codice postale",
      "registrationId": "ID di registrazione del sito di produzione",
      "street": "Via"
    }
  },
  "productionSites": {
    "buttons": {
      "add": "Aggiungi un sito di produzione"
    },
    "create": {
      "error": "Errore al creare il sito di produzione",
      "successCreated": {
        "message": "Il sito di produzione è stato creato correttamente",
        "title": "Sito di produzione creato"
      },
      "successMerged": {
        "message": "Esiste gia nel tuo repository un sito di produzione con questo nome e indirizzo.",
        "title": "Sito di produzione esistente trovato"
      }
    },
    "delete": {
      "error": "Errore al eliminare il sito di produzione",
      "success": {
        "message": "Il sito di produzione è stato eliminato correttamente",
        "title": "Sito di produzione eliminato"
      }
    },
    "filters": {
      "country": "Paese",
      "internalCode": "Codice interno",
      "isConfidential": "Riservato",
      "isConfidentialFalse": "No",
      "isConfidentialTrue": "Sì",
      "name": "Nome del sito di produzione",
      "nothingFoundMessage": "nothingFoundMessage",
      "performedActivities": "Attività svolte",
      "searchPlaceholder": "Cerca filtri",
      "title": "Filtri"
    },
    "search": {
      "placeholder": "Cerca per nome o indirizzo"
    },
    "sorts": {
      "address": "Indirizzo",
      "country": "Paese",
      "email": "Email",
      "internalCode": "Codice interno",
      "name": "Nome"
    },
    "table": {
      "headers": {
        "address": "Indirizzo",
        "certificates": "Certificati",
        "deleted": "Eliminato",
        "id": "ID",
        "internalCode": "Codice interno",
        "name": "Nome",
        "parentCompany": "Azienda madre",
        "performedActivities": "Attività svolte",
        "registrationId": "ID di registrazione del sito"
      }
    },
    "title": "Siti di Produzione",
    "update": {
      "error": "Errore al aggiornare il sito di produzione",
      "partialSave": {
        "message": "message"
      },
      "success": {
        "message": "Il sito di produzione è stato aggiornato correttamente",
        "title": "Sito di produzione aggiornato"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Errore"
    }
  }
}
